// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A4_B","colMin":"styles_colMin__3I4_f"};